module.exports = __webpack_public_path__ + "img/baumliste.5bc4e684.svg";